<template>
  <div class="macro_edit_box" id="macroBox">
    <!-- 极简设置栏 -->
    <div class="macro_header_bar">
      <div class="bar_item">
        <span class="bar_label">{{ $t('macro_mode') }}</span>
        <div class="mode_selector" :class="{ pointer_events_none: record_status }">
          <div class="mode_option" :class="{ active: CycleType == 0 }" @click="changeMode(0)">
            <span class="option_text">{{ $t('macro_one_times') }}</span>
          </div>

          <template v-if="!specialCheck(speciaBehiver.NotSurportMacroPlayOnce, DeviceManager.instance.state.currentPid)">
            <div class="mode_option" :class="{ active: CycleType == 1 }" @click="changeMode(1)">
              <div class="option_content">
                <span class="option_text">{{ $t('macro_more_times') }}</span>
                <div class="times_input_wrapper" v-if="mounted" @click.stop>
                  <input class="inner_input" type="number" v-model="CycleTimes" @blur="changeCycleTimes" />
                  <span class="unit">{{ $t('times') }}</span>
                </div>
              </div>
            </div>
          </template>

          <template v-if="!specialCheck(speciaBehiver.NotSurportMacroPlayStop, DeviceManager.instance.state.currentPid)">
            <div class="mode_option" :class="{ active: CycleType == 2 }" @click="changeMode(2)">
              <span class="option_text">{{ $t('macro_loop_to_press_down') }}</span>
            </div>
          </template>

          <template v-if="!specialCheck(speciaBehiver.NotSurportMacroPlayLoop, DeviceManager.instance.state.currentPid)">
            <div class="mode_option" :class="{ active: CycleType == 3 }" @click="changeMode(3)">
              <span class="option_text">{{ $t('macro_loop_to_press_up') }}</span>
            </div>
          </template>
        </div>
      </div>

      <div class="bar_item">
        <span class="bar_label">{{ $t('macro_record_set') }}</span>
        <div class="config_group" :class="{ pointer_events_none: record_status }">
          <!-- 采用更明显的开关设计 -->
          <div class="custom_switch_wrapper" :class="{ active: enable_delayed }" @click="changeDelayed">
            <div class="switch_track">
              <div class="switch_thumb"></div>
            </div>
            <span class="switch_label">{{ $t('macro_delayed') }}</span>
          </div>
          <div class="config_input" :class="{ disabled: !enable_delayed }">
            <input v-model="delayed_time" type="number" :disabled="!enable_delayed" />
            <span class="unit">ms</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 宏内容主容器 -->
    <div class="macro_content_container">
      <div class="content_header">
        <div class="macro_stats">
          <span class="label">{{ $t('content') }}</span>
          <span class="badge" :class="{ warning: Records && Records.length >= macroLength }"> {{ Records && Records.length }} / {{ macroLength }} </span>
        </div>

        <div class="bar_actions">
          <div class="simple_action_btn" @click="clear">
            <span>{{ $t('clear') }}</span>
          </div>
          <div class="simple_action_btn primary" v-if="!record_status" @click="start">
            <span>{{ $t('macro_record') }}</span>
          </div>
          <div class="simple_action_btn stop" v-else @mousedown.stop="stop">
            <span>{{ $t('stop') }}</span>
          </div>
        </div>
      </div>

      <div class="record_display" :class="{ empty: !Records || Records.length === 0 }">
        <div class="records scrollbar_thumb" ref="recordsRef" v-if="Records && Records.length > 0">
          <template v-for="(item, key) in Records">
            <div class="record_item_wrapper">
              <div class="record_key_box" :class="{ is_down: item.Press }">
                <div class="key_direction">
                  <div class="arrow_icon" :class="{ up: !item.Press, down: item.Press }"></div>
                </div>
                <div class="key_text_box">
                  <div class="mouse_image" v-if="mouseVKs[item.Key]"></div>
                  <span class="key_name">{{ getTexture(item.Key) }}</span>
                </div>
                <!-- 现代化删除按钮 -->
                <div class="item_remove" @click.stop="delKey(key)">
                  <svg viewBox="0 0 24 24" fill="none">
                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>
              </div>

              <!-- 延时组件 -->
              <div class="record_time_box" v-if="Records && Records.length - 1 > key">
                <input class="time_input" type="number" :oninput="checkDelayTime(listenType == ListenType.start ? key + 1 : key)" v-model="Records[listenType == ListenType.start ? key + 1 : key].Delay" :readonly="enable_delayed" />
                <div class="time_unit">ms</div>
              </div>
            </div>
          </template>
        </div>

        <!-- 空状态显示 -->
        <div class="empty_state" v-else>
          <div class="empty_icon_box">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2" ry="2"></rect>
              <path d="M6 8h.01"></path>
              <path d="M10 8h.01"></path>
              <path d="M14 8h.01"></path>
              <path d="M18 8h.01"></path>
              <path d="M6 12h.01"></path>
              <path d="M10 12h.01"></path>
              <path d="M14 12h.01"></path>
              <path d="M18 12h.01"></path>
              <path d="M7 16h10"></path>
            </svg>
          </div>
          <div class="empty_text">
            <p class="main">{{ $t('macro_empty_tip_main') }}</p>
            <p class="sub">{{ $t('macro_empty_tip_sub') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, nextTick } from 'vue'
import { actionSet, ListenType } from '@/service/driver/action_set'
import { operate } from '@/service/driver/operate'
import { kbVKTexture, mediaVKS, mouseVKs } from '@/define/vkcode'
import { onMounted } from 'vue'
import { watch } from 'vue'
import { toRefs } from 'vue'
import { DeviceManager } from '@/service/device'
import { DialogType, enableDialog } from '../cdialog/dialog'
import i18n from '@/languages/i18n'
import { getCurrentDevice } from '@/profiles/selector'
import { speciaBehiver, specialCheck, specialCheckCurrent } from '@/define/limit'
import { VK } from '@/define/define'
import operation_back from './operation_back.vue'
import { onUnmounted } from 'vue'
import { delay } from '@libs/utils/tools'

const { t } = i18n.global
const macroLength = Math.floor(DeviceManager.instance.state.currentDevice.Limit.MacroBytesLen / 4)
const emit = defineEmits(['back', 'submit'])

let { CycleType, CycleTimes, Records } = toRefs(actionSet.macroValue)

let saving = ref(false)
let reseting = ref(false)
const listenType = ref<ListenType>()
let mounted = ref(false)
const recordsRef = ref<HTMLElement | null>(null)

onMounted(() => {
  actionSet.initMacroData()
  actionSet.watchKey()
  mounted.value = true
  watch(actionSet.listenKey, (value) => {
    Records.value = value
    if (record_status.value) {
      if (value.length >= macroLength) {
        stop()
        enableDialog(t('macro_too_long'), DialogType.notice, false)
      }
      nextTick(() => {
        if (recordsRef.value) {
          recordsRef.value.scrollTop = recordsRef.value.scrollHeight
        }
      })
    }
  })
})

onUnmounted(() => {
  mounted.value = false
  stop()
  actionSet.clearListenKey()
})

const checkDelayTime = (key: number) => {
  let maxDelay = 65535
  if (specialCheckCurrent(speciaBehiver.DevicesOfHuoChaiRen) || specialCheckCurrent(speciaBehiver.DevicesOfJingtai_V1)) {
    maxDelay = getCurrentDevice.value.maxDelayTimer
  }

  let delay = Records.value[key].Delay
  if (delay > maxDelay) {
    Records.value[key].Delay = maxDelay
  }
  if (delay < 1) {
    Records.value[key].Delay = 1
  }
}

const getTexture = (vk: VK) => {
  return kbVKTexture[vk] || t(mouseVKs[vk]) || t(mediaVKS[vk])
}

let delayed_time = ref(1)
let enable_delayed = ref(false)
const changeDelayed = () => {
  enable_delayed.value = !enable_delayed.value
  if (delayed_time.value <= 0 && enable_delayed.value) {
    delayed_time.value = 1
  }
}

let record_status = ref(false)
let clearedDuringRecording = false

const delKey = (key: number) => {
  let delay = Records.value[key - 1].Delay
  let cDelay = Records.value[key].Delay

  Records.value[key - 1].Delay = Number(delay) + Number(cDelay)
  Records.value.splice(key, 1)
}

const start = () => {
  if (specialCheckCurrent(speciaBehiver.DeviceOfRoyuan)) {
    record_status.value = true
  }
  record_status.value = true
  listenType.value = ListenType.start
  actionSet.listenkey(ListenType.start)
}
const stopPropagation = (e: Event) => {
  e.stopPropagation()
}
const stop = (): Promise<boolean> => {
  return new Promise((resolve, _) => {
    if (!record_status.value) {
      return resolve(true)
    }
    record_status.value = false
    listenType.value = ListenType.end
    actionSet
      .listenkey(ListenType.end)
      .then((res) => {
        /* 录制中途清空过，丢弃缓冲区数据 */
        if (clearedDuringRecording) {
          clearedDuringRecording = false
          resolve(true)
          return
        }
        if (enable_delayed.value) {
          res.forEach((item) => {
            item.Delay = delayed_time.value
          })
        }
        if (Records.value.length == 0) {
          Records.value.push(...res)
        } else {
          let list = Records.value.slice(-res.length)
          list.forEach((item, index) => {
            if (item.Key == res[index].Key) {
              let rk = Records.value.length - res.length + index
              Records.value[rk].Delay = res[index].Delay
            }
          })
        }

        /* 移除点击“停止”按钮本身产生的鼠标左键记录 (0x01) */
        while (Records.value.length > 0 && Records.value[Records.value.length - 1].Key === 0x01) {
          Records.value.pop()
        }

        resolve(true)
      })
      .catch((_) => {
        resolve(false)
      })
  })
}

const clear = () => {
  if (Records.value && Records.value.length > 0) {
    Records.value.length = 0
    actionSet.listenKey.length = 0
    if (record_status.value) {
      clearedDuringRecording = true
    }
  }
}

const closeMacro = () => {
  if (record_status.value) {
    stop().then(async () => {
      await delay(100)
      emit('back')
    })
    return
  }
  emit('back')
}

const changeMode = (index: number) => {
  CycleType.value = index
  if (CycleType.value != 1) {
    CycleTimes.value = 2
  }
}

const reset = () => {
  if (reseting.value) {
    return
  }
  reseting.value = true
  stop()
  clear()
  initData()
  actionSet.resetBaseValue()?.then(() => {
    reseting.value = false
  })
}

const initData = () => {
  CycleTimes.value = 2
  CycleType.value = 0
  Records.value = []
}

const saveMacro = async () => {
  if (saving.value) {
    return
  }
  if (operate.currentKey.value < 0) {
    enableDialog(t('Please_select_the_button_you_want_to_save'), DialogType.notice, false)
    return
  }
  if (actionSet.macroValue.Records.length > macroLength) {
    enableDialog(t('macro_too_long'), DialogType.notice, false)
    return
  }
  await stop()
  saving.value = true
  actionSet
    .saveMacro()
    ?.then(() => {
      saving.value = false
    })
    .catch(() => {
      saving.value = false
    })
}

watch(delayed_time, (value) => {
  if (value > getCurrentDevice.value.maxDelayTimer) {
    delayed_time.value = getCurrentDevice.value.maxDelayTimer
  }
  if (value < getCurrentDevice.value.minDelayTimer) {
    delayed_time.value = getCurrentDevice.value.minDelayTimer
  }
  if (delayed_time.value > 0) {
    enable_delayed.value = true
  }
})

watch(CycleTimes, (value) => {
  if (value > 255) {
    CycleTimes.value = 255
  }
  if (value !== null && value !== undefined && value < 1) {
    CycleTimes.value = 1
  }
})
const changeCycleTimes = () => {
  if (CycleTimes.value === null || CycleTimes.value === undefined || CycleTimes.value < 1) {
    CycleTimes.value = 2
  }
}

defineExpose({
  saveMacro,
  reset,
})
</script>

<style lang="less" scoped>
.macro_edit_box {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 var(--spacing-panel-x) 0;
  gap: var(--spacing-panel-gap);
  background: transparent;
  box-sizing: border-box;
  overflow: hidden;

  /* 顶部极简工具栏 */
  .macro_header_bar {
    display: flex;
    align-items: center;
    gap: 32px;
    height: 48px; /* 固定高度防止抖动 */
    flex-shrink: 0;
    padding: 0 4px;

    .bar_item {
      display: flex;
      align-items: center;
      gap: 12px;

      .bar_label {
        font-size: 13px;
        font-weight: 700;
        color: var(--color-dark);
        white-space: nowrap;
      }
    }

    /* 模式切换选择器 - 重构为功能卡片感 */
    .mode_selector {
      display: flex;
      gap: 12px;

      .mode_option {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 6px 14px;
        background: var(--color-white);
        border: 1.5px solid rgba(0, 0, 0, 0.04);
        border-radius: var(--radius-s); /* 6px */
        cursor: pointer;
        transition: var(--transition-base);

        .option_text {
          font-size: 12px;
          font-weight: 700;
          color: var(--color-text-hint);
          white-space: nowrap;
          transition: var(--transition-base);
        }

        .option_content {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .times_input_wrapper {
          display: flex;
          align-items: center;
          background: rgba(0, 0, 0, 0.05);
          padding: 1px 6px;
          border-radius: 4px;
          gap: 4px;

          .inner_input {
            width: 28px;
            border: none;
            background: transparent;
            text-align: center;
            font-size: 11px;
            font-weight: 800;
            color: var(--color-brand-1);
            outline: none;
            padding: 0;

            &::-webkit-inner-spin-button {
              display: none;
            }
          }

          .unit {
            font-size: 10px;
            color: var(--color-text-hint);
            font-weight: 600;
          }
        }

        &:hover {
          transform: translateY(-2px);
          border-color: rgba(var(--color-brand-1-rgb), 0.2);
          background: rgba(var(--color-brand-1-rgb), 0.02);

          .option_text {
            color: var(--color-dark);
          }
        }

        &.active {
          background: var(--brand-color);
          border-color: transparent;
          box-shadow: 0 8px 20px rgba(var(--color-brand-1-rgb), 0.15);

          .option_text {
            color: #fff;
          }

          .times_input_wrapper {
            background: rgba(255, 255, 255, 0.2);
            .inner_input,
            .unit {
              color: #fff;
            }
          }
        }
      }
    }

    /* 延时设置 */
    .config_group {
      display: flex;
      align-items: center;
      gap: 12px;

      /* 现代感开关样式 */
      .custom_switch_wrapper {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        padding: 4px 8px;
        border-radius: var(--radius-s);
        transition: var(--transition-base);

        &:hover {
          background: rgba(0, 0, 0, 0.02);
        }

        .switch_track {
          width: 32px;
          height: 16px;
          background: #e5e7eb;
          border-radius: 100px;
          position: relative;
          transition: var(--transition-base);
          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);

          .switch_thumb {
            width: 12px;
            height: 12px;
            background: #fff;
            border-radius: 50%;
            position: absolute;
            left: 2px;
            top: 2px;
            transition: var(--transition-base);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
          }
        }

        .switch_label {
          font-size: 12px;
          font-weight: 600;
          color: var(--color-text-hint);
          transition: var(--transition-base);
        }

        &.active {
          .switch_track {
            background: var(--brand-color);
            box-shadow: 0 0 10px rgba(var(--color-brand-1-rgb), 0.3);
            .switch_thumb {
              left: 18px;
            }
          }
          .switch_label {
            color: var(--color-dark);
          }
        }
      }

      .config_input {
        display: flex;
        align-items: center;
        background: var(--color-white);
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: var(--radius-s);
        padding: 4px 10px;
        gap: 6px;
        transition: var(--transition-base);

        &.disabled {
          opacity: 0.4;
          background: var(--color-gray-1);
          pointer-events: none;
        }

        input {
          width: 40px;
          border: none;
          background: transparent;
          outline: none;
          text-align: center;
          font-weight: 700;
          font-size: 13px;
          color: var(--color-dark);
        }

        .unit {
          font-size: 11px;
          color: var(--color-text-hint);
          font-weight: 600;
        }
      }
    }
  }

  /* 宏内容主容器 - 提升质感 */
  .macro_content_container {
    flex: 0 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0, 0, 0, 0.06);
    border-radius: var(--radius-l);
    background: var(--color-white);

    .content_header {
      border-radius: var(--radius-l) var(--radius-l) 0 0;
      padding: 12px 24px;
      background: rgba(0, 0, 0, 0.015);
      border-bottom: 1px solid rgba(0, 0, 0, 0.04);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .macro_stats {
        display: flex;
        align-items: center;
        gap: 12px;

        .label {
          font-size: 13px;
          font-weight: 700;
          color: var(--color-dark);
        }

        .badge {
          background: var(--color-gray-1);
          padding: 2px 10px;
          border-radius: 100px;
          font-size: 11px;
          color: var(--color-text-hint);
          font-weight: 800;
          border: 1px solid rgba(0, 0, 0, 0.03);

          &.warning {
            color: #fff;
            background: #f23434;
            border-color: transparent;
            animation: pulse 2s infinite;
          }
        }
      }

      /* 动作按钮 - 移至内容头部 */
      .bar_actions {
        display: flex;
        gap: 12px;

        .simple_action_btn {
          height: 32px;
          padding: 0 16px;
          border-radius: var(--radius-m);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          font-weight: 700;
          color: var(--color-text-hint);
          background: var(--color-white);
          cursor: pointer;
          transition: var(--transition-base);
          border: 1.5px solid rgba(0, 0, 0, 0.05);

          &:hover {
            background: #fdfdfd;
            transform: translateY(-2px);
            border-color: var(--color-brand-1);
            color: var(--color-dark);
            box-shadow: 0 6px 15px rgba(0, 0, 0, 0.05);
          }

          &.primary {
            background: var(--brand-color);
            color: #fff;
            border: none;
            box-shadow: 0 8px 20px rgba(var(--color-brand-1-rgb), 0.2);
            &:hover {
              box-shadow: 0 10px 25px rgba(var(--color-brand-1-rgb), 0.3);
            }
          }

          &.stop {
            background: #f23434;
            color: #fff;
            border: none;
            box-shadow: 0 8px 15px rgba(242, 52, 52, 0.2);
            &:hover {
              background: #ff0000;
            }
          }
        }
      }
    }

    .record_display {
      flex: 0 1 auto;
      height: 196px;
      position: relative;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      &.empty {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .records {
        flex: 0 1 auto;
        min-height: 0;
        max-height: 260px;
        padding: var(--spacing-inner-padding);
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        gap: var(--spacing-grid-gap);
        overflow-y: auto;
        overflow-x: hidden;
      }
    }

    /* 空状态 styles - 更加淡雅 */
    .empty_state {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      transition: var(--transition-base);

      .empty_icon_box {
        width: 80px;
        height: 80px;
        color: var(--color-text-hint);
        opacity: 0.2;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      .empty_text {
        text-align: center;
        .main {
          font-size: 15px;
          font-weight: 700;
          color: var(--color-dark);
          opacity: 0.8;
          margin-bottom: 6px;
        }
        .sub {
          font-size: 13px;
          color: var(--color-text-hint);
          opacity: 0.6;
        }
      }
    }

    /* Key Item styles - 现代卡片感 */
    .record_item_wrapper {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .record_key_box {
      min-width: 90px;
      height: 52px;
      background: var(--color-white);
      border: 1px solid rgba(0, 0, 0, 0.05);
      border-radius: var(--radius-m);
      display: flex;
      align-items: center;
      padding: 0 16px;
      gap: 10px;
      position: relative;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.04);
      transition: var(--transition-base);
      cursor: default;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 20%;
        bottom: 20%;
        width: 4px;
        border-radius: 0 4px 4px 0;
      }

      &.is_down {
        background: rgba(var(--color-brand-1-rgb), 0.05);
        border-color: rgba(var(--color-brand-1-rgb), 0.2);
        box-shadow: 0 6px 20px rgba(var(--color-brand-1-rgb), 0.08);
        &::before {
          background: var(--brand-color);
          box-shadow: 0 0 8px rgba(var(--color-brand-1-rgb), 0.5);
        }
      }
      &:not(.is_down) {
        &::before {
          background: #d1d5db;
        }
      }

      .key_direction {
        .arrow_icon {
          width: 14px;
          height: 14px;
          background: url(@/assets/img/icon_down.png) no-repeat center;
          background-size: contain;
          transition: var(--transition-base);

          &.up {
            transform: rotate(180deg);
            filter: grayscale(1);
            opacity: 0.3;
          }
          &.down {
            filter: drop-shadow(0 2px 4px rgba(var(--color-brand-1-rgb), 0.4));
          }
        }
      }

      .key_text_box {
        display: flex;
        align-items: center;
        gap: 6px;
        .key_name {
          font-size: 15px;
          font-weight: 800;
          color: var(--color-dark);
          font-family: 'JetBrains Mono', monospace; /* 如果有的话，增强代码/按键感 */
        }
        .mouse_image {
          width: 16px;
          height: 16px;
          background: url(@/assets/img/mouse_black.png) no-repeat center;
          background-size: contain;
          opacity: 0.7;
        }
      }

      .item_remove {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 20px;
        height: 20px;
        background: #f23434;
        color: #fff;
        border-radius: 50%;
        display: none;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 4px 10px rgba(242, 52, 52, 0.3);
        transform: scale(0.8);
        transition: var(--transition-base);

        &:hover {
          transform: scale(1.1) rotate(90deg);
          background: #ff0000;
        }

        svg {
          width: 12px;
          height: 12px;
        }
      }

      &:hover {
        border-color: var(--color-brand-1);
        transform: translateY(-2px);
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
        .item_remove {
          display: flex;
        }
      }
    }

    .record_time_box {
      display: flex;
      align-items: center;
      background: var(--color-gray-1);
      padding: 4px 10px;
      border-radius: var(--radius-pill);
      gap: 4px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      transition: var(--transition-base);

      &:hover {
        background: var(--color-white);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
        border-color: var(--color-brand-1);
      }

      .time_input {
        width: 32px;
        border: none;
        background: transparent;
        outline: none;
        text-align: center;
        font-size: 11px;
        color: var(--color-brand-2);
        font-weight: 800;
      }
      .time_unit {
        font-size: 10px;
        font-weight: 700;
        color: var(--color-text-hint);
        opacity: 0.7;
      }
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}
</style>
